import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { TeamParametersettingsListComponent } from 'src/app/configuration/team-parametersettings-list/team-parametersettings-list.component';
import { PlayerService } from 'src/app/shared/player.service';
import { PlayerSearchParameters } from '../models/PlayerSearchParameters';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatAnchor } from '@angular/material/button';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-player-search',
    templateUrl: './player-search.component.html',
    styleUrls: ['./player-search.component.css'],
    imports: [ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatHint, MatSelect, MatOption, MatAnchor, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, RouterLink, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, DatePipe]
})
export class PlayerSearchComponent implements OnInit {

  displayedColumns: string[] = ['LastName', 'FirstName', 'DateOfBirth', 'Weight', 'Height', 'Actions'];
  dataSource:any;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  searchForm;
 
  
  constructor(public playerRep: PlayerService) { 

  }

  ngOnInit() {
    this.searchForm = new UntypedFormGroup({
      FirstName: new UntypedFormControl(''),
      LastName: new UntypedFormControl('', Validators.required),
      PositionIds: new UntypedFormControl(''),
      
    });
  }
 


  searchPlayers(){

    var p: PlayerSearchParameters;
    p = new PlayerSearchParameters();
    p = this.searchForm.value;
    //console.log(p);
    //console.log(this.searchForm.value);
    //p.FirstName = "Andreas";

    this.playerRep.searchPlayers(this.searchForm.value).subscribe( result=>{
        
        this.dataSource = new MatTableDataSource(result);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        //console.log(result);
        
    });
  }

}
